import { api } from '@/api';
import { ProtocolDto } from '@/api/generator';
import { SelectItemTypeObject } from '@/components/forms/types';
import { throttle } from 'lodash';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useProtocolsStore = defineStore('protocols', () => {
  const protocols = ref<ProtocolDto[]>();

  async function update() {
    const { result } = await api.protocolsApi.getProtocolCatalog();
    if (result) {
      protocols.value = result;
    }
  }

  async function initialize() {
    if (!protocols.value) {
      await update();
    }
  }

  const options = computed<SelectItemTypeObject<ProtocolDto>[]>(
    () =>
      protocols.value?.map((protocol) => ({
        title: protocol.name,
        value: protocol,
      })) || [],
  );

  function getById(id?: string | null) {
    return id ? protocols.value?.find((p) => p.id === id) : undefined;
  }

  return {
    initialize: throttle(initialize, 500),
    update,
    getById,
    options,
    protocols,
  };
});
